import { IDbBaseMetadataValueInfos } from "./i-db-base-metadata-value-infos";
import { JobStatus } from "./job-status";
import { ObjectStatus } from "./object-status";
import { PostActionType } from "./post-action-type";

export class DbJobRulePostActionInfos {
  $type: string | null = null;
  enabled: boolean | null = null;
  type: PostActionType | null = null;
  jobStatuses: JobStatus[] | null = null;
  status?: ObjectStatus | null = null;
  body?: string | null = null;
  recipients?: string | null = null;
  metadata?: IDbBaseMetadataValueInfos | null;
  uuid?: string | null = null; // Front ONLY

  constructor(init?: Partial<DbJobRulePostActionInfos>) {
    Object.assign(this, init);
  }
}
